import { render, staticRenderFns } from "./PaymentMethodSummary.vue?vue&type=template&id=6d7f6bdd"
import script from "./PaymentMethodSummary.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports